module.exports = __webpack_public_path__ + "static/media/logo.2c2209ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo.png
// module id = 339
// module chunks = 6